import {
  Box,
  Button,
  NumberInput,
  NumberInputField,
  Td,
  Tr
} from "@chakra-ui/react";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { ModeloItemOrcamentoCategoria } from "models/modelo_item_orcamento_categoria";
import { ModeloItemOrcamentoProduto } from "models/modelo_item_orcamento_produto";
import { NewProduct } from "models/new_product_type";
import { OptionType } from "models/select_mode";
import formatNumber from "views/admin/order/hooks/formatNumber";
  
  interface IItemRow {
    categ: ModeloItemOrcamentoCategoria
    item: ModeloItemOrcamentoProduto;
    produtos: NewProduct[];
    showError: (title: string, msg: string) => void;
    deleteRow: (item: ModeloItemOrcamentoProduto, categ: ModeloItemOrcamentoCategoria) => void;
    editRow: (item: ModeloItemOrcamentoProduto, categ: ModeloItemOrcamentoCategoria) => void;
  }
  
  const ItemRow = ({
    item,
    produtos,
    showError,
    deleteRow,
    editRow,
    categ
  }: IItemRow) => {
    const onChangeInput = (item: ModeloItemOrcamentoProduto, value: string, type: string) => {
      switch (type) {
        case "produto":
          const prd = produtos?.find((a) => a.id === value);
          if (prd) {
            item.novoProdutoId = prd.id;
            item.valorUn = prd.precoVenda;
          }
          break;
  
        case "qtd":
          item.quantidade = Number(value);
          break;


  
        default:
          break;
      }
      calculaTotal();
    };
  
    const calculaTotal = () => {
      const calc = item.NovoProduto?.precoVenda * item.quantidade;
      item.valorTotal = calc;
      editRow(item, categ);
    };
  
    return (
      <Tr>
        <Td>
          <Box w={300}>
            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size="md"
              onChange={(e) => {
                onChangeInput(item, e.value, "produto");
              }}
              placeholder="Buscar..."
              isDisabled={false}
              name={"Produto"}
              options={produtos?.map((item) => {
                return {
                  label: item?.nome,
                  value: item?.id,
                };
              })}
              value={{
                label: item?.NovoProduto?.nome,
                value: item.NovoProduto.id,
              }}
            />
          </Box>
        </Td>
        <Td>{item?.NovoProduto?.sku}</Td>
        <Td> {item?.NovoProduto?.nome}</Td>
        <Td>
          <NumberInput
            precision={2}
            defaultValue={item?.quantidade}
            style={{
              width: 100,
            }}
            name={`quantidade--`}
            onBlur={(e) => {
              onChangeInput(item, e.target.value, "qtd");
            }}
          >
            <NumberInputField />
          </NumberInput>
        </Td>
        <Td>
          {isNaN(item?.NovoProduto?.precoVenda)
            ? formatNumber(0)
            : formatNumber(Number(item?.NovoProduto?.precoVenda))}
        </Td>
        <Td>{formatNumber(Number(item.valorTotal))}</Td>
        <Td>
          <Button
            onClick={() => {
              deleteRow(item, categ);
            }}
            colorScheme="red"
            variant="ghost"
            ml="1"
          >
            Excluir
          </Button>
        </Td>
      </Tr>
    );
  };
  
  export default ItemRow;
  